module.exports = "/* You can add global styles to this file, and also import other style files */\n.row{\n    margin-left:0px !important;\n    margin-right:0px !important;\n}\nbody{\n    font-family: sans-serif;\n}\n::-webkit-scrollbar { \n    display: none; \n}"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/styles.css
// module chunks = styles